import { render } from "./App.vue?vue&type=template&id=61821e76"
const script = {}

import "./App.vue?vue&type=style&index=0&id=61821e76&lang=scss"

import exportComponent from "/Users/wang/work/soulex/nebula-fe/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__